//allows for use of window.Cypress to determine if we are in a testing environment
import {getBaseUrl} from "./helper-methods";
import {MessageObj, StateResult, StrengthObjType} from "./interfaces";
import {Colors} from "../styles/constants";

declare global {
  interface Window {
    Cypress:any;
  }
}

//used for testing
export const defaultSiteKey = '6LfRvtUbAAAAAMBaRr15zTsD35JzultqOVoCp0iQ';

export const isTest = process.env.NODE_ENV === 'test' || !!window.Cypress;

export const defaultMerchantRedirect = getBaseUrl() + '/dashboard/';

export const defaultPersonalRedirect = getBaseUrl() + '/id/home';

export const defaultTestingRedirect = getBaseUrl() + '/success-test/';

// valid for Salesforce
export const countriesOfResidence = [
  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antigua And Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos(Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, the Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  'Côte d\'Ivoire',
  'Croatia',
  'Curaçao',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands(Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea - Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See(Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea, Republic of',
  'Kosovo',
  'Kuwait',
  'Lao People\'s Democratic Republic',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, The Former Yugoslav Republic Of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Réunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barthélemy',
  'Saint Helena',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin(French Part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten(Dutch Part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Taiwan, Province of China',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor - Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela',
  'Vietnam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

// Countries Under GDPR
// previously used to determine if marketing opt in question should be shown, no longer used
export const restrictedCountries = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Canada',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Guernsey',
  'Hungary',
  'Iceland',
  'Ireland',
  'Isle of Man',
  'Italy',
  'Jersey',
  'Latvia',
  'Lichtenstein',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Netherlands',
  'Norway',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
  'Turkey',
  'United Kingdom'
];

export const usStates: StateResult[] = [
  {
    name: 'Alabama',
    abbreviation: 'AL'
  },
  {
    name: 'Alaska',
    abbreviation: 'AK'
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ'
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR'
  },
  {
    name: 'California',
    abbreviation: 'CA'
  },
  {
    name: 'Colorado',
    abbreviation: 'CO'
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT'
  },
  {
    name: 'Delaware',
    abbreviation: 'DE'
  },
  {
    name: 'District Of Columbia',
    abbreviation: 'DC'
  },
  {
    name: 'Florida',
    abbreviation: 'FL'
  },
  {
    name: 'Georgia',
    abbreviation: 'GA'
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI'
  },
  {
    name: 'Idaho',
    abbreviation: 'ID'
  },
  {
    name: 'Illinois',
    abbreviation: 'IL'
  },
  {
    name: 'Indiana',
    abbreviation: 'IN'
  },
  {
    name: 'Iowa',
    abbreviation: 'IA'
  },
  {
    name: 'Kansas',
    abbreviation: 'KS'
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY'
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA'
  },
  {
    name: 'Maine',
    abbreviation: 'ME'
  },
  {
    name: 'Maryland',
    abbreviation: 'MD'
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA'
  },
  {
    name: 'Michigan',
    abbreviation: 'MI'
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN'
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS'
  },
  {
    name: 'Missouri',
    abbreviation: 'MO'
  },
  {
    name: 'Montana',
    abbreviation: 'MT'
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE'
  },
  {
    name: 'Nevada',
    abbreviation: 'NV'
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH'
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ'
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM'
  },
  {
    name: 'New York',
    abbreviation: 'NY'
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC'
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND'
  },
  {
    name: 'Ohio',
    abbreviation: 'OH'
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK'
  },
  {
    name: 'Oregon',
    abbreviation: 'OR'
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA'
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI'
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC'
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD'
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN'
  },
  {
    name: 'Texas',
    abbreviation: 'TX'
  },
  {
    name: 'Utah',
    abbreviation: 'UT'
  },
  {
    name: 'Vermont',
    abbreviation: 'VT'
  },
  {
    name: 'Virginia',
    abbreviation: 'VA'
  },
  {
    name: 'Washington',
    abbreviation: 'WA'
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV'
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI'
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY'
  }
];

export const yearlyRevenueOptions = [
  {
    value: '0-2M',
    label: '$ 0 - 2 M',
  },
  {
    value: '2-25M',
    label: '$ 2 - 25 M',
  },
  {
    value: '25-150M',
    label: '$ 25 - 150 M',
  },
  {
    value: '150-500M',
    label: '$ 150 - 500 M',
  },
  {
    value: '500M-2B',
    label: '$ 500 M - 2 B',
  },
  {
    value: '2B+',
    label: '$ 2 B+',
  },
];

export const employeeCounts = [
  {
    value: '0-10',
    label: '0 - 10'
  },
  {
    value: '11-100',
    label: '11 - 100'
  },
  {
    value: '101-1000',
    label: '101 - 1000'
  },
  {
    value: '1000+',
    label: '1000+'
  }
]

export const industries = [
  'Administrative & Support Services',
  'Arts, Entertainment & Recreation',
  'Charitable / Nonprofits',
  'Education',
  'Financial Services & Products',
  'Healthcare',
  'Hospitality',
  'Information Technology (IT)',
  'Luxury Good',
  'Professional & Shared Services',
  'Real Estate',
  'Retail & Consumer',
  'Travel & Transportation',
  'Warehousing',
]

export const orgTypes = [
  {
    value: 'sole',
    label: 'Self-employed'
  },
  {
    value: 'private',
    label: 'Private Company'
  },
  {
    value: 'public',
    label: 'Publicly Traded Company'
  },
  {
    value: 'nonprofit',
    label: 'Non-Profit or Tax-Exempt'
  },
  {
    value: 'other',
    label: 'Other / Not Sure'
  },
]

export const defaultStrengthObj:StrengthObjType = {
  value: 0,
  description: null,
  color: Colors.Caution
};

export const defaultMessageObj:MessageObj = {
  message: '',
  type: 'warning'
}

export const ErrorExpiration = 5000;

export const personalOnlyDest = [
  'poynt',
  'payoutInvite',
  'verify'
];

export const businessOnlyDest = [
  'shopify'
];

/**
 * When the waitlist is turned on for business signup these are the values of
 * ?apply that allow the user to bypass the waitlist
 */
export const businessWaitlistGateKeys = [
  'nowaitlist'
]

export const TierOneTraits = {
  industries: [
    'Airlines/Aviation',
    'Alternative Dispute Resolution',
    'Alternative Medicine',
    'Animation',
    'Apparel/Fashion',
    'Architecture/Planning',
    'Arts/Crafts',
    'Automotive',
    'Aviation/Aerospace',
    'Broadcast Media',
    'Building Materials',
    'Business Supplies/Equipment',
    'Civil Engineering',
    'Cloud Hosting',
    'Commercial Real Estate',
    'Computer Games',
    'Computer Networking',
    'Computer Software/Engineering',
    'Computer/Network Security',
    'Construction',
    'Consumer Goods',
    'Cosmetics',
    'Dairy',
    'Defense/Space',
    'Design',
    'Dietary Supplements',
    'E-commerce',
    'E-Learning',
    'eCommerce',
    'Education Management',
    'Entertainment',
    'Environmental Services',
    'Farming',
    'File Sharing',
    'Fine Art',
    'Fishery',
    'Fitness',
    'Food Production',
    'Food/Beverages',
    'Fund-Raising',
    'Government Administration',
    'Graphic Design/Web Design',
    'Health/Fitness',
    'Higher Education/Acadamia',
    'Higher Education/Academia',
    'Hospital/Health Care',
    'Hospitality',
    'Import/Export',
    'Information Services',
    'Information Technology/IT',
    'International Trade/Development',
    'Internet',
    'Law Enforcement',
    'Law Practice/Law Firms',
    'Legal Services',
    'Leisure/Travel/Tourism',
    'Libraries',
    'Logistics/Supply Chain',
    'Luxury Goods/Jewelry',
    'Maritime',
    'Market Research',
    'Marketing/Advertising/Sales',
    'Media Production',
    'Medical Devices/Equipment',
    'Medical Practice',
    'Mental Health Care',
    'Military',
    'Motion Pictures/Film',
    'Museums/Institutions',
    'Music',
    'Newspapers/Journalism',
    'Non-Profit/Fundraising',
    'Non-Profit/Volunteering',
    'NonProfit',
    'Online Publishing',
    'Package/Freight Delivery',
    'Paper/Forest Products',
    'Performing Arts',
    'Pharmaceuticals',
    'Philanthropy',
    'Photography',
    'Primary/Secondary Education',
    'Printing',
    'Program Development',
    'Public Relations/PR',
    'Public Safety',
    'Publishing Industry',
    'Ranching',
    'Real Estate/Mortgage',
    'Recreational Facilities/Services',
    'Religious Institutions',
    'Research Industry',
    'Restaurants',
    'Retail Industry',
    'Security/Investigations',
    'Software Development',
    'Sporting Goods',
    'Sports',
    'Supermarkets',
    'Technology/IT',
    'Telecommunications',
    'Transportation',
    'Utilities',
    'Veterinary',
    'Video on Demand',
    'VPN/Hosting',
    'Warehousing',
    'Wholesale',
    'Wireless',
    'Writing/Editing'
  ],
  countries: ['United States'],
  orgTypes: ['private', 'sole', 'non-profit'],
}
